module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-view"
  }, [_c('create-header-bar'), _c('create-menu-bar', {
    attrs: {
      "editor": _vm.editor
    },
    on: {
      "showView": _vm.showView,
      "toggleEditor": function($event) {
        _vm.editor = !_vm.editor
      }
    }
  }), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [(_vm.view) ? _c('div', {
    staticClass: "slider"
  }, [_c('button', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.view = null
      }
    }
  }), (_vm.view) ? _c(_vm.view, {
    tag: "component",
    attrs: {
      "params": _vm.params
    },
    on: {
      "showView": _vm.showView,
      "close": function($event) {
        _vm.view = null
      }
    }
  }) : _vm._e()], 1) : _vm._e()]), _c('iframe', {
    ref: "wikiFrame",
    staticClass: "wikiFrame",
    attrs: {
      "src": _vm.wikiUrl
    }
  }), _c('iframe', {
    ref: "createFrame",
    staticClass: "frame",
    attrs: {
      "src": _vm.frameUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21a04856!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/CreateView.vue
// module id = 585
// module chunks = 2